// extracted by mini-css-extract-plugin
export default {"Toaster":"ToasterhQ2RbJU_bDYh"};